import useLocalStorage from '../../../shared/hooks/useLocalStorage';
import { useEContext } from '../../../shared/components/EContext';

export function useIntroductionTour(): [boolean, (show: boolean) => void] {
    const { identity } = useEContext();

    const agreementNo = !!identity ? identity.currentAgreement.number : 0;

    const [show, setShow, clear] = useLocalStorage(`agreement.${agreementNo}.introduction-tour.show`, false);

    function set(value: boolean) {
        if (!value) {
            clear();
        } else {
            setShow(true);
        }
    }

    return [show, set];
}
